/* eslint-disable ember/classic-decorator-hooks */
import EmberObject from '@ember/object';

import FilterConstants from '../../../../filter-constants';
import * as CommonUtils from '../../../../utils/common';

export default class MultipleFeedbackLowPassIdealOpAmp extends EmberObject {
  // Inputs
  r1 = null;
  r2 = null;
  r5 = null;
  c1 = null;
  c2 = null;
  optimization = null;
  stageFp = null;
  gain = null;
  stageQ = null;
  algorithm = null;

  // Outputs
  iBias = null;
  gbw = null;
  rOut = null;
  specialGain = 1;
  name = 'ideal';
  slewRate = 0;
  rOutOverGBW = FilterConstants.Limits.INFINITY;

  init() {
    super.init();

    if (
      CommonUtils.isNullOrUndefined(this.r1) ||
      CommonUtils.isNullOrUndefined(this.r2) ||
      CommonUtils.isNullOrUndefined(this.r5) ||
      CommonUtils.isNullOrUndefined(this.c1) ||
      CommonUtils.isNullOrUndefined(this.c2) ||
      CommonUtils.isNullOrUndefined(this.stageFp) ||
      CommonUtils.isNullOrUndefined(this.stageQ) ||
      CommonUtils.isNullOrUndefined(this.gain) ||
      CommonUtils.isNullOrUndefined(this.optimization) ||
      CommonUtils.isNullOrUndefined(this.algorithm)
    ) {
      throw 'Required values are incomplete. Please provide r1, r2, r5, c1, c2, stageFp, stageQ, gain, optimization, and algorithm';
    }

    this.iBias = this.computeIBias();
    this.gbw = this.computeGbw();
    this.rOut = this.computeROut(this.gbw);
  }

  computeGbw() {
    var allowedError = this.optimization.opAmpRequirementSpecValues.allowedError;
    var numerator =
      this.stageFp * (-2 * this.stageQ * this.gain + Math.sqrt((this.c1 * this.r5) / (this.c2 * this.r2)));
    var denominator = 2 * allowedError;
    var result = (numerator * this.gain) / denominator;
    return result;
  }

  computeIBias() {
    var dcOutputVoltageFromIBias = this.optimization.opAmpRequirementSpecValues.dcOutputVoltageFromIBias;
    var iBiasResistance = this.r2 + CommonUtils.parallel(this.r1, this.r5);
    return dcOutputVoltageFromIBias / iBiasResistance / this.gain;
  }

  computeROut(gbw) {
    return this.rOutOverGBW * gbw;
  }
}
